export const PROMPT_DEFAULT = "You are a helpful AI assistant for the Admin Dashboard.";

export const constants = {
  PROMPT_DEFAULT
};
